import React, { useEffect, useState } from 'react';
import "antd/dist/antd.css";
import './App.css';
import Login from "./Pages/Login";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import SignUp from './Pages/SignUp';
import ChatWindow from './Pages/chat_window/ChatWindow';
import Cashback from './Pages/Cashback';
import PageOqimoqda from './Pages/PageOqimoqda';
function App() {
  const [auth, setAuth] = useState(false)
  let user = JSON.parse(window.localStorage.getItem("user"))
  useEffect(() => {
    if (user) {
        setAuth(user.Id)
    }  
    
  }, []) 
  return (
    <BrowserRouter>
      <div className={auth ? "App_back": "App"}>
        <Switch>
          <Route exact path="/">
              {auth ? ((user.holati == "0" || user.holati == "5" ||user.holati == "2") ? <Cashback user={user}></Cashback> : <PageOqimoqda user={user}></PageOqimoqda>) : <Login ></Login>}
          </Route>
          <Route exact path="/signup">
              <SignUp></SignUp>
          </Route>
          <Route exact path="/chat">
            <ChatWindow user={user} isOpen={true} 
        title="My Messages"></ChatWindow>
          </Route>
        </Switch>       
      </div>
    </BrowserRouter>
  );
}

export default App;
